import { onMounted, onUnmounted, ref, type Ref } from 'vue';

import {
  buildFixedEndDashSegments,
  type DashSegment,
  type FixedEndDashOptions,
} from './buildFixedEndDashSegments';

export function useCenteredDashedUnderline(
  elementRef: Ref<HTMLElement | null>,
  options: FixedEndDashOptions = {},
) {
  const width = ref(0);
  const segments = ref<DashSegment[]>([]);

  function update(): void {
    const el = elementRef.value;
    if (!el) return;

    const elementWidth = el.getBoundingClientRect().width;
    width.value = elementWidth;
    segments.value = buildFixedEndDashSegments(elementWidth, options);
  }

  let resizeObserver: ResizeObserver | null = null;

  onMounted(() => {
    if (!elementRef.value) return;

    update();
    resizeObserver = new ResizeObserver(update);
    resizeObserver.observe(elementRef.value);
  });

  onUnmounted(() => {
    resizeObserver?.disconnect();
  });

  return { width, segments };
}
